/* @flow */
import * as React from "react";
import { line as d3Line, curveMonotoneX } from "d3-shape";
import * as Types from "./NextGenChartTypes";

const defaultLine = d3Line();
const curvedLine = d3Line().curve(curveMonotoneX);

type Props = {
  data: Array<Types.RenderablePoint>,
  curved: boolean,
  shadow: boolean,
  viewportWidth: number,
  viewportHeight: number
};

function filterButLeavePadding<T>(
  data: Array<T>,
  iteratee: (T, number, Array<T>) => boolean
): Array<T> {
  let result = [];
  let previous = false;

  for (let i = 0; i < data.length; i++) {
    const current = iteratee(data[i], i, data);

    if (previous === false && current === true && i > 0) {
      result.push(data[i - 1]);
    }

    if (current === true || previous === true) {
      result.push(data[i]);
    }

    previous = current;
  }

  return result;
}

const Path = React.memo(function({
  data,
  curved,
  shadow,
  viewportWidth,
  viewportHeight,
  ...props
}: Props) {

  const windowedData = filterButLeavePadding(
    data,
    point => point[0] >= 0 && point[0] <= viewportWidth
  );

  let displayedData = windowedData;

  if (shadow && windowedData.length > 0) {
    const [firstX, , firstSource] = windowedData[0];
    const [lastX, , lastSource] = windowedData[windowedData.length - 1];

    displayedData = [
      ...windowedData,
      [lastX, viewportHeight, lastSource],
      [firstX, viewportHeight, firstSource]
    ];
  }

  const d = curved ? curvedLine(displayedData) : defaultLine(displayedData);

  return (
    <path
      d={d}
      {...props}
    />
  );
});

export default Path;



// WEBPACK FOOTER //
// ./src/components/Chart/Path.js